export default __webpack_public_path__ + "locales/ar-SA/ConvertDialog.json?hash=7b095fa60491fa4552ce3a0903a3adc8";